import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [sectionId, setSectionId] = useState(null);

  return (
    <AppContext.Provider value={{ sectionId, setSectionId }}>
      {children}
    </AppContext.Provider>
  );
};
